import alienEmoji from "../assets/emoji/alien.png";
import vEmoji from "../assets/emoji/v.png";
import faceBlowingAKissEmoji from "../assets/emoji/face-blowing-a-kiss.png";
import faceSavoringFoodEmoji from "../assets/emoji/face-savoring-food.png";
import faceWithRaisedEyebrowEmoji from "../assets/emoji/face-with-raised-eyebrow.png";
import guitarEmoji from "../assets/emoji/guitar.png";
import pizzaEmoji from "../assets/emoji/pizza.png";
import hornsEmoji from "../assets/emoji/horns.png";
import smilingFaceWithSunglassesEmoji from "../assets/emoji/smiling-face-with-sunglasses.png";
import studioMicrophoneEmoji from "../assets/emoji/studio-microphone.png";
import sunflowerEmoji from "../assets/emoji/sunflower.png";
import unicornEmoji from "../assets/emoji/unicorn.png";
import partyPassEmoji from "../assets/emoji/party-pass.png";
import basicPassEmoji from "../assets/emoji/basic-pass.png";
import returningUserEmoji from "../assets/emoji/returning-user.png";
import defaultEmoji from "../assets/emoji/default-emoji.png";

const emojis = [
  { name: "smiling-face-with-sunglasses", src: smilingFaceWithSunglassesEmoji },
  { name: "face-blowing-a-kiss", src: faceBlowingAKissEmoji },
  { name: "face-savoring-food", src: faceSavoringFoodEmoji },
  { name: "face-with-raised-eyebrow", src: faceWithRaisedEyebrowEmoji },
  { name: "sunflower", src: sunflowerEmoji },
  { name: "unicorn", src: unicornEmoji },
  { name: "pizza", src: pizzaEmoji },
  { name: "alien", src: alienEmoji },
  { name: "studio-microphone", src: studioMicrophoneEmoji },
  { name: "guitar", src: guitarEmoji },
  { name: "v", src: vEmoji },
  { name: "horns", src: hornsEmoji },
];

export const passIcons = {
  party: partyPassEmoji,
  basic: basicPassEmoji,
  returning: returningUserEmoji,
};

export const defaultEmojiImage = defaultEmoji;

export default emojis;
